export default {
    data: {
        canonicalUrls: {
            tw: 'https://www.twerenbold.ch',
            mi: 'https://www.mittelthurgau.ch',
            im: 'https://www.imbach.ch',
            qt: 'https://staging.twerenbold.ch',
            qm: 'https://staging.mittelthurgau.ch',
            qi: 'https://staging.imbach.ch'
        },
        isRemembered: false,
    },
    methods: {
        getTravelRatingData: function () {
            var self = this;
            axios.get(this.surveyEp)
                .then(function (response) {
                    self.tripRatingData = response.data.data;
                })
                .catch(function (error) {
                    self.handleApiError(error);
                });
        },
        getShipData: function (shipcode) {
            if (!shipcode) return;
            var self = this;
            var shipEp = this.shipEp.replace('{code}', shipcode)
            axios.get(shipEp)
                .then(function (response) {
                    self.shipData = response.data.data;
                })
                .catch(function (error) {
                    self.handleApiError(error);
                });
        },
        getVideoId: function (url) {
            if (url.length > 0) {
                return VueYouTubeEmbed.getIdFromURL(url)
            }
            return null;
        },
        loadBusPano: function () {
            var self = this;
            var bus = this.tripData.busse;
            if(!bus)return;
            var busses = [];
            if(bus.includes('_')){
                busses = bus.split('_');
            } else {
                busses.push(bus);
            }
            busses.forEach(function(bus){
                axios.get('/ccm/pano/' + bus)
                    .then(function (response) {
                        self.busPano = response.data;
                    })
                    .catch(function (error) {
                        self.handleApiError(error);
                    });
            });
        },
        loadBusPanoCombined: function () {
            var self = this;
            var bus = this.tripData.busse;
            axios.get('/ccm/pano/' + bus)
                .then(function (response) {
                    self.busPano = response.data;
                })
                .catch(function (error) {
                    self.handleApiError(error);
                });
        },
        loadShipPano: function (shipcode) {
            if (!shipcode) return;
            var self = this;
            axios.get('/ccm/pano/' + shipcode)
                .then(function (response) {
                    self.shipPano = response.data;
                })
                .catch(function (error) {
                    self.handleApiError(error);
                });
        },
        loadFancyBox: function () {
            // Some default configs for Fancyapps
            this.Fancybox.bind('[data-fancybox]', {
                Thumbs: {
                    autoStart: false,
                },
                Toolbar: {
                    display: ["counter", "zoom", "slideshow", "fullscreen", "thumbs", "close"],
                },
            });
            this.Fancybox.bind('[data-fancybox="deckplan"], [data-fancybox="kabinenplan"], [data-fancybox="programm"]', {
                Thumbs: {
                    autoStart: false,
                },
                Toolbar: {
                    display: ["close"],
                },
                Image: {
                    Panzoom: {
                        maxScale: function () {
                            return 3;
                        },
                    },
                },
            });
            this.Fancybox.bind('[data-fancybox="pano-ship"], [data-fancybox="pano-bus-koenig"], [data-fancybox="pano-bus-komfort"]', {
                Thumbs: {
                    autoStart: false,
                },
                Toolbar: {
                    display: ["close"],
                },
                on: {
                    done: (fancybox, slide) => {
                        initPano();
                    },
                },
            });
            this.Fancybox.bind('[data-fancybox="krpano-ship"], [data-fancybox="krpano-koenig"], [data-fancybox="krpano-komfort"]', {
                Thumbs: {
                    autoStart: false,
                },
                Toolbar: {
                    display: ["close"],
                },Carousel: {
                    infinite: false,
                    touch: false,
                },
                closeButton: 'outside',
                animated: false,
                hideScrollbar: true,
                trapFocus: true,
                dragToClose: false,
                infinite: false,
                touch: false,
                mainClass: 'krpano-wrapper',
                on: {
                },
            });
            this.Fancybox.bind('[data-fancybox="reviews"]', {
                Thumbs: {
                    autoStart: false,
                },
                Toolbar: {
                    display: ["close"],
                },
                dragToClose: false,
                infinite: false,
                mainClass: 'reviews-wrapper',
                closeButton: 'outside',
            });
        },
        transformHotelCategory: function (cat) {
            var num = cat.charAt(0);
            var symbol = '•';
            var plus = (cat.includes('+') ? '+' : '');
            return symbol.repeat(num) + plus;
        },
        getSafe: function (fn) {
            try {
                return fn();
            } catch (e) {
                return false;
            }
        },
        toggleDropdown: function (e) {
            this.showJumpbarDropdown = !this.showJumpbarDropdown;
        },
        closeDropdown: function (e) {
            this.showJumpbarDropdown = false;
        },
        replParkingSign: function (string) {
            return string.replace(new RegExp('<parken/>', 'g'), '<i class="icon icon-052 inline blackBG"></i>');
        },
        mergeImageInfo: function(image){
            if(!typeof image === 'Object')return '';
            var string = '';
            if(image.hasOwnProperty('legende')){
                string += image.legende;
            }
            if(image.hasOwnProperty('copyright')){
                string += ' ©' + image.copyright;
            }
            return string;
        },
        checkRemember: function() {
            var rememberedTravels = [];
            if(window.localStorage && window.localStorage.getItem('travel-list')){
                rememberedTravels = window.localStorage.getItem('travel-list').split(',').filter(function (item) {
                    return item.length != 0
                });
            }
            if (rememberedTravels.length > 0) {
                if (rememberedTravels.includes(this.tripData.code)) this.isRemembered = true;
            }
        },
        toggleRemember: function () {
            var code = this.tripData.code;
            if(code) {
                // make sure we have an array in our local storage
                if (!('travel-list' in window.localStorage)) {
                    window.localStorage['travel-list'] = '';
                }
                if (this.isRemembered) {
                    // remove code
                    window.localStorage['travel-list'] = window.localStorage['travel-list'].replace(code + ',', '');
                    this.isRemembered = false;
                } else {
                    // add code
                    window.localStorage['travel-list'] += code + ',';
                    this.isRemembered = true;
                }
            }
            setCartState();
        }
    },
    computed: {
        tripUrl: function () {
            if(!this.isPreview){
                return this.companyCannonical + '/reise/' + this.sanitizeTitle(this.tripData.tdbez) + '-' + this.tripData.code;
            }
            else return '';
        },
        tripUri: function() {
            return '/reise/' + this.sanitizeTitle(this.tripData.tdbez) + '-' + this.tripData.code;
        },
        cannonicalTripUrl: function() {
            return this.canonicalUrls[this.tripData.mandant] + '/reise/' + this.sanitizeTitle(this.tripData.tdbez) + '-' + this.tripData.code;
        },
        tripMainImg: function() {
            if(this.tripData.bilder && this.tripData.bilder[0]) {
                return this.tripData.bilder[0].filenames.hauptbild_detail_lg;
            }
            return '';
        },
        minDuration: function () {
            var durations = [];
            if(this.tripData.durchfuehrungen)this.tripData.durchfuehrungen.forEach(element => durations.push(
                Math.ceil(
                    Math.abs((Date.parse(element.abreisedatum) - Date.parse(element.rueckreisedatum))) / (1000 * 60 * 60 * 24) + 1
                )
            ));
            return Math.max.apply(Math, durations);
        },
        minPrice: function () {
            var prices = [];
            if(this.tripData.durchfuehrungen)this.tripData.durchfuehrungen.forEach(element => prices.push(
                element.preis
            ));
            return Math.min.apply(Math, prices);
        },
        bookingButtonText: function() {
            if(this.hasBookable)return 'Reise buchen';
            if(this.tripData.ausgebucht === true)return 'Ausgebucht';
            return 'Reise in Planung';
        },
        buttonText: function () {
            if (!this.hasBookable && this.tripData.durchfuehrungen && this.tripData.durchfuehrungen.length > 0) {
                return 'Alle Reisen ausgebucht';
            }else if (!this.hasBookable && (!this.tripData.durchfuehrungen || this.tripData.durchfuehrungen.length == 0)) {
                return 'Reise in Planung';
            }else if (this.minPrice && this.tripData.reiseart == 'Ausflüge') {
                return 'Ab ' + this.$options.filters.toCurrency(this.minPrice);
            }else if (this.minDuration && this.minPrice) {
                if(this.minDuration === 1){
                    return this.minDuration + ' Tag ab ' + this.$options.filters.toCurrency(this.minPrice);
                } else {
                    return this.minDuration + ' Tage ab ' + this.$options.filters.toCurrency(this.minPrice);
                }
            }else{
                return '';
            }
        },
        hasBookable: function () {
            if(this.tripData.durchfuehrungen){
                var d = this.tripData.durchfuehrungen.filter(function(e){
                    return e.status === 'FREE' || e.status === 'REQUEST' || e.status === 'LESS'
                });
                if(d.length > 0){
                    return true;
                }
            }
            return false;
        }
    },
    filters: {
        toCurrency: function (value) {
            if (isNaN(value)) {
                return '';
            }
            if(value % 1 != 0){
                var formatter = new Intl.NumberFormat('de-ch', {
                    style: 'currency',
                    currency: 'CHF',
                    minimumFractionDigits: 2
                });
                return formatter.format(value);
            } else {
                var formatter = new Intl.NumberFormat('de-ch', {
                    style: 'currency',
                    currency: 'CHF',
                    minimumFractionDigits: 0
                });
                return formatter.format(value) + '.–';
            }
        },
        toDateString: function (value) {
            return moment(value).locale('de').format('DD.MM.YY')
        },
        toDateStringShort: function (value) {
            return moment(value).locale('de').format('DD.MM.')
        },
        toDateStringComplete: function (value) {
            return moment(value).locale('de').format('DD.MM.YY HH:mm:ss')
        },
        toDateDay: function (value) {
            return moment(value).locale('de').format('dd')
        },
        titleToSlug: function(title) {
            if(!title){
                return '';
            }
            let slug = "";
            // Change to lower case
            let titleLower = title.toLowerCase();
            // Letter "e"
            slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
            // Letter "c"
            slug = slug.replace(/ç/gi, 'c');
            // Letter "a"
            slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
            slug = slug.replace(/ä/gi, 'ae');
            // Letter "o"
            slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
            slug = slug.replace(/ö/gi, 'oe');
            // Letter "u"
            slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
            slug = slug.replace(/ü/gi, 'ue');
            // Letter "d"
            slug = slug.replace(/đ/gi, 'd');
            // Trim the last whitespace
            slug = slug.replace(/\s*$/g, '');
            // Change whitespace to "-"
            slug = slug.replace(/\s–\s/g, '-');
            slug = slug.replace(/\s–\s/g, '-');
            slug = slug.replace(/\s+/g, '-');
            // Special Chars
            slug = slug.replace(/&|%|:/gi, '');
            slug = slug.replace('?', '');
            slug = slug.replace(/\//gi, '-');
            // Reduce multiple dashes
            slug = slug.replace(/----/gi, '-');
            slug = slug.replace(/---/gi, '-');
            slug = slug.replace(/--/gi, '-');
            return slug;
        }
    },
    mounted(){

    }
};